// import bp from './brakePoints';
import Swiper from 'swiper';

let all = $('.js-slided-tabs');

if (all.length > 0) {
	all.each(function() {
		let $c = $(this);
		let slider;
		
		slider = new Swiper($c, {
			slidesPerView: 'auto',
			slidesToShow: 'auto',
			freeMode: true,
			freeModeSticky: true,
			resistanceRatio: 0.1,
			slideToClickedSlide: true
		});
		
	});
}
